import React from 'react';
import './footer.styles.scss';

const Footer = () => (
    <div className="footer">
        <p>Made with <span className="fa fa-heart heart"></span> by Chinmay Mehta   
             <span role="img" aria-label="smiley" className="smile">&#128513;</span>
        </p>
    </div>
);

export default Footer;
